export default __webpack_public_path__ + "static/media/Transform.3c0f8124.mp3";